import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';

import { QueueManagementStrategy } from 'generated/graphql-types';
import { QueueManagementStrategyOption } from '../models/queue-management-option';
import { queueManagementStrategyOptionActions } from './queue-management-option.actions';

export const queueManagementStrategyOptionFeatureKey = 'queueManagementStrategyOptions';

export type QueueManagementStrategyOptionState = EagerSelectState<QueueManagementStrategyOption>;

const adapter = createEagerSelectAdapter<QueueManagementStrategyOptionState, QueueManagementStrategyOption>({
   featureKey: queueManagementStrategyOptionFeatureKey,

   selectId: (strategy: QueueManagementStrategyOption) => {
      return strategy.queueManagementStrategyTypeId ?? '';
   },
});

export const queueManagementStrategyOptionSelectors = adapter.getSelectors(filterQueueManagementStrategyOption);

const initialState = adapter.getInitialState();

export const queueManagementStrategyOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,

   queueManagementStrategyOptionActions.search,
   queueManagementStrategyOptionActions.searchReset,

   queueManagementStrategyOptionActions.loadFromApi,
   queueManagementStrategyOptionActions.loadFromApiSuccess,
   queueManagementStrategyOptionActions.loadFromApiFailure
);

export function filterQueueManagementStrategyOption<T extends QueueManagementStrategyOption>(
   types: T[],
   searchText: string | null | undefined
): T[] {
   const filteredOptions: T[] = Object.values(QueueManagementStrategy)
      .filter((strategy) => {
         if (searchText) {
            return strategy.toLowerCase().includes(searchText.toLowerCase());
         }

         return true;
      })
      .map((strategy) => {
         return {
            queueManagementStrategyTypeId: strategy,
         } as T;
      });

   return filteredOptions;
}
